export default __webpack_public_path__ + "static/media/react.bad5cd8a.png";